module.exports = __webpack_public_path__ + "static/media/Search.a8197291.png";